import { writable } from 'svelte/store';
let initialDisabled = true;
const { subscribe, update, set } = writable(initialDisabled);
const disabled = {
    subscribe,
    update,
    set
};
export default disabled;
